import ControlPanelContainer from 'dashboard/apps/DashboardLayoutEditor/ControlPanel/ControlPanelContainer';
import { ViewLayout } from 'dashboard/modules/Resource';
import { ModuleResourceTransaction } from 'dashboard/modules/ResourceTransaction';
import Checkbox from 'design-system/components/Checkbox';
import Select, { Option } from 'design-system/components/Select';
import Spacer from 'design-system/components/Spacer';
import { Heading, Label, Paragraph } from 'design-system/components/Text';

const VIEW_LAYOUT_OPTIONS = [
  { value: 'list', label: 'List' },
  { value: 'table', label: 'Table' },
];

export interface ResourceTransactionPanelProps {
  module: ModuleResourceTransaction;
  updateModule: (module: ModuleResourceTransaction) => void;
}

const ResourceTransactionPanel = ({ module, updateModule }: ResourceTransactionPanelProps) => {
  const viewLayoutInput = module['view-layout'];

  const handleUpdateViewLayoutInput = (viewLayoutInput: ViewLayout) => {
    updateModule({
      ...module,
      'view-layout': viewLayoutInput,
    });
  };

  const handleSetHideEmptyAttributes = (hideEmptyAttributes: boolean) => {
    updateModule({
      ...module,
      'hide-empty-attributes': hideEmptyAttributes,
    });
  };

  return (
    <ControlPanelContainer>
      <Heading size='sm'>Settings</Heading>
      <Spacer height={2} />
      <Label id='transaction-view-layout-selector-label' size='md' weight='bold'>
        View layout
      </Label>
      <Select
        portal={true}
        value={viewLayoutInput ?? 'list'}
        onValueChange={handleUpdateViewLayoutInput}
        aria-labelledby='transaction-view-layout-selector-label'
      >
        {VIEW_LAYOUT_OPTIONS.map((opt) => (
          <Option key={opt.value} value={opt.value}>
            {opt.label}
          </Option>
        ))}
      </Select>
      <Spacer height={2} />
      <Checkbox
        label={<Paragraph>Hide empty fields</Paragraph>}
        checked={module['hide-empty-attributes'] ?? false}
        onChange={(e) => {
          handleSetHideEmptyAttributes(e.target.checked);
        }}
      />
    </ControlPanelContainer>
  );
};

export default ResourceTransactionPanel;
